import { useQuery } from '@apollo/client/react'
import {
  DocumentStage,
  OpenDocumentsDocument,
  type ScanCenterCode,
} from '~app/graph/generated/graphql'

function getSanitizedCustomer(
  customerId: string | null | undefined
): string | null {
  if (customerId === 'NULL') {
    return null
  }
  return customerId
}

/**
 * Fetch documents data + setup subscriptions for update/delete of documents
 */
const useDocumentData = ({
  taggerFiltered,
  tagger,
  customerId,
  excludeCustomerId,
  excludeScanCenter,
  scanCenterId,
}: {
  taggerFiltered: boolean
  tagger: string | undefined
  customerId: string
  excludeCustomerId: boolean
  excludeScanCenter: boolean
  scanCenterId: ScanCenterCode
}) => {
  const documentsQuery = useQuery(OpenDocumentsDocument, {
    skip: !tagger,
    variables: {
      // maximum total count of 100 documents to prevent huge payloads
      first: 100,
      where: {
        // filter by scancenter ID
        [excludeScanCenter ? 'scanCenter_not' : 'scanCenter']: scanCenterId,

        // filter for tagger
        tagger: taggerFiltered ? tagger : undefined,

        stage: DocumentStage.ManualProcessingStarted,

        // filter by customer ID
        ...(!customerId
          ? {}
          : excludeCustomerId
            ? { customer: { id_not: getSanitizedCustomer(customerId) } }
            : { customer: { id: getSanitizedCustomer(customerId) } }),
      },
    },
    fetchPolicy: 'network-only',
  })

  return documentsQuery
}

export default useDocumentData
